import { useSelector } from "react-redux";
import HorizantalBar from "../../../components/horizantalBar/HorizantalBar";
import PageLink from "../../../components/pageLink/PageLink";
import { allowedTabs } from "../../../constants/permissionCatalog";
import SocialMediaNavigator from "../../../navigation/SocialMediaNavigator";
import styles from "./socialMediaSettings.module.css";

const SocialMediaSettings = () => {
  const { rolePermissions } = useSelector((state) => state.user);
  const tabs = allowedTabs("social-media", rolePermissions);

  return (
    <div className={styles.container}>
      <HorizantalBar>
        <div className={styles.linksWrapper}>
          {tabs.map((tab) => (
            <div key={tab.id} className={styles.linkWrapper}>
              <PageLink destination={`/dashboard/social-media/${tab.path}`}>{tab.label}</PageLink>
            </div>
          ))}
        </div>
      </HorizantalBar>
      <SocialMediaNavigator />
    </div>
  );
};

export default SocialMediaSettings;
